import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import { SiSalesforce } from 'react-icons/si';
import { MdOutlineAnalytics } from 'react-icons/md';

import { SaleUsersPage, SalesAnalysisPage } from './pages';
import { SalesAnalysisDatatable } from './pages/SalesAnalysisDatatable';
import { SalesPromoCodeAnalysisPage } from './pages/SalesPromoCodeAnalysis';

export const initializeSalesRoutes: InitializerExecutor = async (dispatch) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Sales',
        href: '/sales',
        per: ['139.2', '139.3', '139.4', '139.6', '139.7', '139.8'],
        icon: SiSalesforce,
        children: [
          {
            name: 'Sale Users',
            href: '/sale-users',
            per: ['139.2', '139.6', '139.7', '139.8'],
          },
          {
            name: 'Branches',
            href: '/branches',
            per: ['139.3', '139.4'],
          },
          {
            name: 'Sales Analysis',
            href: '/sales-analysis',
            per: ['139.9'],
          },
          {
            name: 'Sales Analysis Table',
            href: '/sales-analysis-table',
            per: ['139.10'],
          },
        ],
      },
      {
        name: 'Sales Promo Code Analysis',
        href: '/sales-promocode-analysis',
        per: ['139.11'],
        icon: MdOutlineAnalytics,
      },
    ])
  );
};

export const initializeSalesEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'sale-users',
        per: ['139.2', '139.6', '139.7', '139.8'],
        crump: 'Sale Users',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: SaleUsersPage,
            per: ['139.2', '139.6', '139.7', '139.8'],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'sales-analysis',
        per: ['139.9'],
        crump: 'Sales Analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: SalesAnalysisPage,
            per: ['139.9'],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'sales-analysis-table',
        per: ['139.10'],
        crump: 'Sales Analysis Table',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: SalesAnalysisDatatable,
            per: ['139.10'],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'sales-promocode-analysis',
        per: ['139.11'],
        crump: 'Sales Promo Code Analysis',
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: SalesPromoCodeAnalysisPage,
            per: ['139.11'],
          },
        ],
      },
    ])
  );
};
